import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import ids from 'Components/Worksheets/QestIds';
import { BsMeasurementsGridSection, BsMeasurementsSection, BsPreparationSection, BsResultsSection } from './Sections';

const qestIds = [ids.particleDensity.BS_1377_2_Clause_9_2.rev2022];

const BsParticleDensityWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Sample Preparation">
        <BsPreparationSection />
      </PageSection>
      <PageSection heading="Measurements">
        <BsMeasurementsSection />
        <BsMeasurementsGridSection />
      </PageSection>
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <WorksheetResultsSection heading="Results">
        <BsResultsSection />
      </WorksheetResultsSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

BsParticleDensityWorksheet.qestIds = qestIds;

export default BsParticleDensityWorksheet;
export { BsParticleDensityWorksheet };
